import { Configuration as ConfigurationV1, DefaultHandshakePainterServiceApi as DefaultHandshakePainterServiceApiV1, } from '@amzn/handshake-painter-typescript-client/v1';
import { fetchApiInterceptor } from './apiInterceptor';
// Allow overriding the API URL at build time
const getApiBaseUrl = () => {
    const host = window.location.host;
    // For production traffic, fetch backend API url dynamically
    if (host.includes('social.amazon')) {
        return host.startsWith('app.') ? host.replace('app.', 'api.') : `api.${host}`;
    }
    // For gamma EU traffic
    if (host.includes('eu-central-1')) {
        return 'api.eu-central-1.painter.handshake.amazon.dev';
    }
    if (host.includes('eu-south-2')) {
        return 'api.eu-south-2.painter.handshake.amazon.dev';
    }
    // For every other deployed env, we will default to the gamma backend url
    else {
        return 'api.painter.handshake.amazon.dev';
    }
};
// Use the environment variable if provided in local testing, otherwise generate a default URL
const basePath = process.env.HANDSHAKE_API_BASE_URL || `https://${getApiBaseUrl()}`;
const HANDSHAKE_PAINTER_SERVICE_CONFIGURATION = {
    basePath,
    fetchApi: fetchApiInterceptor,
    credentials: 'include',
};
export const HandshakePainterServiceApiV1 = new DefaultHandshakePainterServiceApiV1(new ConfigurationV1(HANDSHAKE_PAINTER_SERVICE_CONFIGURATION));
